@if (showSpinner) {
<app-loader> </app-loader>
}
<div class="main-dashboard-wrapper">
  <div class="inner-section-dashboard">

    <div class="attendance-grid-container">

      <div class="attendance-grid-card working-hours-border-color">
        <div class="card-detail-top">
          <div class="card-round-image bg-color-1">
            <img src="../../../assets/attendance/alarm-clock-check.svg" alt="ico">
          </div>
          <h1 class="card-inner-text">Working Hours</h1>
        </div>
        <div class="card-detail-bottom">
          <div class="left-side-data">
            <h2 class="hours-count">{{ workingHoursTotalAssignMonth }} </h2>
            <p class="hours-text">HOURS</p>
          </div>
          <div class="right-side-data">
            <div class="colored-dot dot-lightGreen"></div>
            <p class="dot-text">Total Days</p>
            <p class="dot-count">{{workingHoursTotalAssignMonth_totalDays}}</p>
          </div>
        </div>
      </div>

      <div class="attendance-grid-card working-hours-border-color-c2">
        <div class="card-detail-top">
          <div class="card-round-image bg-color-2">
            <img src="../../../assets/attendance/users-check.svg" alt="ico">
          </div>
          <h1 class="card-inner-text">Worked Hours</h1>
        </div>
        <div class="card-detail-bottom">
          <div class="left-side-data">
            @if (stats.length > 0) {
            <h2 class="hours-count">{{ stats[0].worked_time | number : '1.2-2' }}</h2>
            }
            <p class="hours-text">HOURS</p>
          </div>
          <div class="right-side-2nd-card">
            <div class="right-side-data-c2 ">
              <div class="colored-dot dot-lightGreen"></div>
              <p class="dot-text">Leaves</p>
              <p class="dot-count">{{totalLeaves}}</p>
            </div>
            <div class="right-side-data-c2">
              <div class="colored-dot dot-lightGreen"></div>
              <p class="dot-text">Absent</p>
              <p class="dot-count">{{totalAbsent}}</p>
            </div>
          </div>

        </div>
      </div>

      <div class="attendance-grid-card working-hours-border-color-c3">
        <div class="card-detail-top">
          <div class="card-round-image bg-color-3">
            <img src="../../../assets/attendance/over-time.svg" alt="ico">
          </div>
          <h1 class="card-inner-text">Over Time</h1>
        </div>
        <div class="card-detail-bottom">
          <div class="left-side-data">
            <h2 class="hours-count">{{ overtime === null ? "0" : overtime }}</h2>
            <p class="hours-text">HOURS</p>
          </div>
          <div class="right-side-data">
            <div class="colored-dot dot-lightGreen"></div>
            <p class="dot-text">Total Days</p>
            <p class="dot-count">{{overtimeDays}}</p>
          </div>
        </div>
      </div>

      <div class="attendance-grid-card working-hours-border-color-c4">
        <div class="card-detail-top">
          <div class="card-round-image bg-color-4">
            <img src="../../../assets/attendance/alarm-clock-off.svg" alt="ico">
          </div>
          <h1 class="card-inner-text">Missing Punch Ins</h1>
        </div>
        <div class="card-detail-bottom">
          <div class="left-side-data">
            @if (stats.length > 0) {
            <h2 class="hours-count">{{ stats[0].check_in_missed || 0 }}</h2>
            }
            <p class="hours-text">TIMES</p>
          </div>
          <!-- <div class="right-side-data">
          <div class="colored-dot dot-lightGreen"></div>
          <p class="dot-text">Total Days</p>
          <p class="dot-count">10</p>
        </div> -->
        </div>
      </div>

      <div class="attendance-grid-card working-hours-border-color-c5">
        <div class="card-detail-top">
          <div class="card-round-image bg-color-5">
            <img src="../../../assets/attendance/clock-refresh.svg" alt="ico">
          </div>
          <h1 class="card-inner-text">Late Punch Ins</h1>
        </div>
        <div class="card-detail-bottom">
          <div class="left-side-data">
            @if (stats.length > 0) {
            <h2 class="hours-count">{{ stats[0].check_in_late }}</h2>
            }
            <p class="hours-text">HOURS</p>
          </div>
          <div class="right-side-data">
            <div class="colored-dot dot-lightGreen"></div>
            <p class="dot-text">Total Days</p>
            <p class="dot-count">{{totalCheckOutMissed}}</p>
          </div>
        </div>
      </div>

      <div class="attendance-grid-card working-hours-border-color-c6">
        <div class="card-detail-top">
          <div class="card-round-image bg-color-6">
            <img src="../../../assets/attendance/clock-fast-forward.svg" alt="ico">
          </div>
          <h1 class="card-inner-text">Short Hours</h1>
        </div>
        <div class="card-detail-bottom">
          <div class="left-side-data">
            @if (stats.length > 0) {
            <h2 class="hours-count">{{ stats[0].total_short_time | number : '1.2-2' }}</h2>
            }
            <p class="hours-text">HOURS</p>
          </div>
          <div class="right-side-data">
            <div class="colored-dot dot-lightGreen"></div>
            <p class="dot-text">Total Days</p>
            <p class="dot-count">{{shorthoursDays}}</p>
          </div>
        </div>
      </div>


    </div>

    <div class="header-inner-setion">
      <div class="inner-common">
        <div class="card-main">
          <div class="row">
            <div class="col-12">
              <div class="card-heading">
                <h1>Today Report</h1>
              </div>
            </div>
            <div class="today-report-main">
              <div class="comon-report-section">
                <div class="semidonut-chart-section">
                  <div class="semi-donut margin" style="--percentage : {{percentageInProgress}};  margin: 0 auto;">
                    <div class="report-timer">
                      <h1>
                        {{remaininghours ?? "00"}}
                        <span class="full-form">Hours</span>
                        <span class="short-form">HH</span>
                      </h1>
                      <h1>
                        :
                      </h1>
                      <h1>
                        {{remainingminutes ?? "00"}}
                        <span class="full-form">Minutes</span>
                        <span class="short-form">MM</span>

                      </h1>
                      <h1>
                        :
                      </h1>
                      <h1>
                        {{remaininseconds ?? "00"}}
                        <span class="full-form">Seconds</span>
                        <span class="short-form">SS</span>

                      </h1>
                    </div>
                  </div>
                  <div class="punchin-button">
                    @if (shouldShowPunchIn()) {
                    <button class="pounch-in" (click)="getCheckInDetail()" [disabled]="isSecondShiftEmployee()">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.00008 5.5415V7.87484L8.45841 8.74984M7.00008 2.9165C4.26167 2.9165 2.04175 5.13643 2.04175 7.87484C2.04175 10.6132 4.26167 12.8332 7.00008 12.8332C9.73849 12.8332 11.9584 10.6132 11.9584 7.87484C11.9584 5.13643 9.73849 2.9165 7.00008 2.9165ZM7.00008 2.9165V1.1665M5.83341 1.1665H8.16675M11.8587 3.26186L10.9837 2.38686L11.4212 2.82436M2.14151 3.26186L3.01651 2.38686L2.57901 2.82436"
                          stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      Punch In
                    </button>
                    }
                    @if (shouldShowPunchOut()) {
                    <button (click)="getCheckOutDetail()" [disabled]="isSecondShiftEmployee()">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.00008 5.5415V7.87484L8.45841 8.74984M7.00008 2.9165C4.26167 2.9165 2.04175 5.13643 2.04175 7.87484C2.04175 10.6132 4.26167 12.8332 7.00008 12.8332C9.73849 12.8332 11.9584 10.6132 11.9584 7.87484C11.9584 5.13643 9.73849 2.9165 7.00008 2.9165ZM7.00008 2.9165V1.1665M5.83341 1.1665H8.16675M11.8587 3.26186L10.9837 2.38686L11.4212 2.82436M2.14151 3.26186L3.01651 2.38686L2.57901 2.82436"
                          stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      Punch Out
                    </button>
                    }

                  </div>

                </div>
              </div>
              <div class="comon-report-section">
                <div class="shift-detail-section">
                  <div class="col-12 p-0">
                    <div class="shift-detail-head">
                      <h1>Shift Details</h1>
                    </div>
                  </div>
                  <div class="shift-detail-main">
                    <div class="shift-time">
                      <div class="border-section">
                        <div class="circle bule-circle">

                        </div>
                      </div>
                      <div class="shit-content-sec">
                        <h2>Shift Time</h2>
                        <h1>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M7.00008 3.49984V6.99984L9.33341 8.1665M12.8334 6.99984C12.8334 10.2215 10.2217 12.8332 7.00008 12.8332C3.77842 12.8332 1.16675 10.2215 1.16675 6.99984C1.16675 3.77818 3.77842 1.1665 7.00008 1.1665C10.2217 1.1665 12.8334 3.77818 12.8334 6.99984Z"
                              stroke="#2D2D2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                          <span>{{ user.usershittime[0].start_time ?? "00:00" }}</span> To
                          <Span>{{user.usershittime[0].end_time ?? "00"}}</Span>
                        </h1>
                      </div>
                    </div>

                    <div class="shift-time">
                      <div class="border-section">
                        <div class="circle pink-circle">

                        </div>
                      </div>
                      <div class="shit-content-sec">
                        <h2>Total Shift Hours</h2>
                        <h1>
                          <svg width="12" height="14" viewBox="0 0 12 14" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M6.00008 5.5415V7.87484L7.45841 8.74984M6.00008 2.9165C3.26167 2.9165 1.04175 5.13643 1.04175 7.87484C1.04175 10.6132 3.26167 12.8332 6.00008 12.8332C8.73849 12.8332 10.9584 10.6132 10.9584 7.87484C10.9584 5.13643 8.73849 2.9165 6.00008 2.9165ZM6.00008 2.9165V1.1665M4.83341 1.1665H7.16675M10.8587 3.26186L9.98365 2.38686L10.4212 2.82436M1.14151 3.26186L2.01651 2.38686L1.57901 2.82436"
                              stroke="#2D2D2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                          <span>{{user.usershittime[0].total_working_hours ?? 0}} Hours</span>
                        </h1>
                      </div>
                    </div>
                    <div class="shift-time">
                      <div class="border-section last-border-section">
                        <div class="circle yellow-circle">

                        </div>
                      </div>
                      @if ((checkInTime != null ) && (checkOutTime == null || checkOutTime === "")) {
                      <div class="shit-content-sec">
                        <h2>Punch in at</h2>
                        <h1>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M8.45841 11.0832L9.62508 12.2498L12.2501 9.62484M12.8247 7.3206C12.8305 7.21441 12.8334 7.10746 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.1705 3.69638 12.7503 6.84753 12.8312M7.00008 3.49984V6.99984L9.1808 8.0902"
                              stroke="#2D2D2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                          <span>{{ checkInTime ?? "Need to Do Punch In" }}</span>
                        </h1>
                      </div>
                      } @else {
                      <div class="shit-content-sec">
                        <h2>Punch out at</h2>
                        <h1>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M8.45841 11.0832L9.62508 12.2498L12.2501 9.62484M12.8247 7.3206C12.8305 7.21441 12.8334 7.10746 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.1705 3.69638 12.7503 6.84753 12.8312M7.00008 3.49984V6.99984L9.1808 8.0902"
                              stroke="#2D2D2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                          <span>{{ checkOutTime }}</span>
                        </h1>
                      </div>
                      }
                      
                  
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inner-common">
        <div class="card-main">
          <div class="row">
            <div class="col-12">
              <div class="card-heading">
                <h1 class="mb-0">Attendance Report</h1>
                <div class="chart-button">
                  <button (click)="filterBars('all')">
                    <div class="chart-color all-bar"></div>All
                  </button>
                  <button (click)="filterBars('overtime')">
                    <div class="chart-color overtime-bar"></div> Overtime
                  </button>
                  <button (click)="filterBars('allGood')">
                    <div class="chart-color allgood-bar"></div>All Good
                  </button>
                  <button (click)="filterBars('shortTime')">
                    <div class="chart-color short-bar"></div>Short Time
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 p-0">
            <div id="chart">
              <apx-chart [series]="chartOptions.series" [grid]="chartOptions.grid"
                [dataLabels]="chartOptions.dataLabels" [chart]="chartOptions.chart"
                [plotOptions]="chartOptions.plotOptions" [colors]="chartOptions.colors"></apx-chart>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="filter-container">
      <div class="left-filter">
        <h1 class="filter-txt">Filter</h1>
      </div>
      <div class="right-filter">
          <form #f="ngForm" (ngSubmit)="onSubmit(f)">

          <!-- <input type="text" class="search-input" placeholder="Search by name" /> -->
          <select id="attendancetype" name="attendancetype" class="search-input" ngModel #attendancetype="ngModel">
            <option value="" disabled selected>Select Type</option>
            <option value="LastMonth">Last Month</option>
            <option value="ThisMonth">Current Month</option>
          </select>
          <input type="text" placeholder="Start Date" onfocus="this.type='date'; this.showPicker()"
            onblur="if(!this.value) this.type='text'" name="startdate" id="startdate" class="date-picker"
            id="datetimepicker4" ngModel #startdate="ngModel" />
          <input type="text" onfocus="this.type='date'; this.showPicker()" onblur="if(!this.value) this.type='text'"
            class="date-picker" placeholder="End Date" name="enddate" id="enddate" ngModel #enddate="ngModel" />
          <button type="submit" class="apply-btn">Apply</button>
          <button type="button" class="apply-btn reset-btn" (click)="onReset(f)">Reset</button>

        </form>
          <button class="apply-btn show-request" (click)="Attendacereq()">Show Correction Req</button>
          @if (hasDoubleAttendance) {
          <button class="apply-btn overtime-btn" data-toggle="modal" data-target="#bulkOvertimeModal">Apply Overtime</button>
          }
        </div>



    </div>



    <div class="table-container">
      <table class="custom-table">
        <colgroup>
          <col style="width: 16%;"> <!-- Date -->
          <col style="width: 12%;"> <!-- Check In -->
          <col style="width: 12%;"> <!-- Check Out -->
          <col style="width: 12%;"> <!-- Working Hours -->
          <col style="width: 28%;"> <!-- Status -->
          <col style="width: 20%;"> <!-- Action -->
        </colgroup>
        <thead>
          <tr>
            <th style="border-top-left-radius: 10px; ">Date</th>
            <th>Punch In</th>
            <th>Punch Out</th>
            <th>Working Hours</th>
            <th>Status</th>
            <th style="border-top-right-radius: 10px; ">Action</th>
          </tr>
        </thead>
      </table>

      <div class="table-container">
        @for (type of typeArr; track type) {
        <app-user-attendance-type [type]="type" [paidLeaves]="paidLeaves" [unpaidLeaves]="unpaidLeaves"
          [pendingLeaves]="pendingLeaves" [shortLeaves]="shortLeaves"> </app-user-attendance-type>
        }
      </div>

    </div>
  </div>


<!-- Bulk Overtime Modal -->
<div class="modal fade" id="bulkOvertimeModal">
  <div class="modal-dialog modal-lg" style="margin: 30px auto;">
    <div class="modal-content">
      <div class="modal-header text-white" style="padding: 15px; display: flex; align-items: center; background-color: #3b82f6;">
        <p class="modal-title" style="font-size: 1.2rem; font-weight: bold;">Bulk Overtime Application</p>
        <button type="button" class="close text-white" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body" style="padding: 20px; background-color: #f9fafb;">
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Check In</th>
                <th>Check Out</th>
                <th>Overtime Hours</th>
              </tr>
            </thead>
            <tbody>
              @for (record of doubleAttendanceRecords; track record.date) {
              <tr>
                <td class="overtime-date">{{ record.date | date: 'EEEE' }} {{ record.date | date: 'dd MMM' }}</td>
                <td>
                  <input type="time" class="form-control" [(ngModel)]="record.check_in" (ngModelChange)="calculateBulkOvertime(record)">
                </td>
                <td>
                  <input type="time" class="form-control" [(ngModel)]="record.check_out" (ngModelChange)="calculateBulkOvertime(record)">
                </td>
                <td>
                  <input type="number" class="form-control" [(ngModel)]="record.overtime_hours">
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="form-group mt-3">
          <label style="font-weight: bold; margin-bottom: 10px;">Detail (Reason)</label>
          <textarea class="form-control text-area" rows="4" [(ngModel)]="bulkOvertimeReason" placeholder="Min 50 characters required..."></textarea>
          @if (bulkOvertimeReason.trim().length < 50) {
            <small class="text-danger">Need {{ 50 - bulkOvertimeReason.trim().length }} more characters.</small>
          }
        </div>
      </div>
      <div class="modal-footer" style="padding: 15px; border-top: 1px solid #e5e7eb; gap: 10px;">
        <button type="button" class="btn btn-secondary p-2" data-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary p-2" [disabled]="bulkOvertimeReason.trim().length < 50" (click)="applyBulkOvertime()">Submit Requests</button>
      </div>
    </div>
  </div>
</div>